import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { SIGN_IN_PATH } from '../../utils/constants';

const NotAllowed = () => {
  return (
    <p>
      Access to this feature requires additional permissions. Please contact your account manager to
      enable this feature, or reach out to our support team if you need assistance.
    </p>
  );
};

const ProtectedRoute = ({ children, ...rest }) => {
  const [notAllowed, setNotAllowed] = useState(false);
  const { isUserEntitled, isAuthenticated, loading } = useCurrentUser();

  useEffect(() => {
    if (isAuthenticated && !isUserEntitled(rest.path)) {
      setNotAllowed(true);
    }
  }, [isAuthenticated, isUserEntitled, rest.path]);

  // Show loading state while authentication is being determined
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  if (!isAuthenticated) {
    const params = new URLSearchParams(window.location.search);
    return (
      <Redirect
        to={{
          pathname: SIGN_IN_PATH,
          state: { from: rest.location },
          search: params.toString(),
          hash: window.location.hash,
        }}
      />
    );
  }

  if (notAllowed) return <NotAllowed />;

  return <Route {...rest} render={() => children} />;
};

export default ProtectedRoute;
